import { render } from "./IconLogout.vue?vue&type=template&id=29c33005"
const script = {}

import exportComponent from "E:\\salekWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__